import React from 'react';
import * as ethicalInboxService from '../../services/ethical-inbox/EthicalInbox';

const EthicalInboxContext = React.createContext();
const { Provider, Consumer } = EthicalInboxContext;

class EthicalInboxProvider extends React.Component {
  state = {
    response: null,
  };

  constructor(props) {
    super(props);
    this.sendReport = this.sendReport.bind(this);
    this.sendResponse = this.sendResponse.bind(this);
    this.edit = this.edit.bind(this);
  }

  async sendReport(data) {
    return new Promise(async (resolve, reject) => {
      await ethicalInboxService
        .sendReport(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async sendResponse(data) {
    return new Promise(async (resolve, reject) => {
      await ethicalInboxService
        .sendResponse(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async edit(id) {
    return new Promise(async (resolve, reject) => {
      await ethicalInboxService
        .edit(id)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        value={{
          response: this.state.response,
          sendReport: this.sendReport,
          sendResponse: this.sendResponse,
          edit: this.edit,
        }}
      >
        {children}
      </Provider>
    );
  }
}

export default EthicalInboxContext;

export { EthicalInboxProvider, Consumer };
